import React, { useState, useEffect, forwardRef } from "react";
import _ from "lodash";
import "./MoleculeStructure.css";
import initRDKit from "../layout/utils/initRDKit";

//mostly taken from rdkit.js docs
const MoleculeSVG = forwardRef((props, ref) => {
  function drawSVG() {
    if (!props.rdKit) {
      console.log("RDKit not loaded");
      return;
    }
    try {
      const mol = props.rdKit.get_mol(props.smiles);

      var canvas = document.getElementById("canvas-" + props.smiles);
      if (canvas === null) {
        return;
      }
      mol.draw_to_canvas(canvas, 100, 100);
    } catch (err) {
      console.log(err);
      return;
    }

    // return (
    //   <div
    //     style={{
    //       width: props.width ? props.width : "100%",

    //       height: props.height ? props.height : "100%",
    //     }}
    //     dangerouslySetInnerHTML={{ __html: new_svg }}
    //   ></div>
    // );
  }

  // useEffect(() => {
  //   if (rdkit === undefined) {
  //     initRDKit().then((rd) => {
  //       setRdkit(rd);
  //     });
  //   }
  // }, []);

  return drawSVG();
});

export default MoleculeSVG;
